import { createApi } from '@reduxjs/toolkit/dist/query/react';

import fetchBaseQuery from '@app/api/fetchBaseQuery';

export interface ConfirmationTokenDetails {
    verified: boolean;
    expired: boolean;
}

const emailConfirmationApi = createApi({
    reducerPath: 'lokaliseInternal_emailConfirmation',
    baseQuery: fetchBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        resendEmailVerification: builder.mutation({
            query: () => ({
                url: '/confirmation/resend-email-verification',
                method: 'POST',
            }),
        }),
        changeVerificationEmail: builder.mutation<void, { email: string }>({
            query: (payload) => ({
                url: '/confirmation/try-another-email',
                method: 'POST',
                body: payload,
            }),
        }),
        getConfirmationTokenDetails: builder.query<ConfirmationTokenDetails, void>({
            query: () => ({
                url: '/confirmation/token-details',
                method: 'GET',
            }),
        }),
    }),
});

export default emailConfirmationApi;
